module.exports.app_id = "Notify";

module.exports.api_url = "https://notify-api.polymedia.nl";
module.exports.api_token = "777vps";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://192.168.0.10:3001";
	module.exports.api_token = "123";
}



// WEBPACK FOOTER //
// ./src/config.js